import { render, staticRenderFns } from "./ASysAdminForms.vue?vue&type=template&id=c02a5e50&"
import script from "./ASysAdminForms.vue?vue&type=script&lang=ts&"
export * from "./ASysAdminForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports